import { createSlice } from '@reduxjs/toolkit';

type scrollYStateType = {
  homePageScrollY: number;
  infoListPageScrollY: number;
  productListPageScrollY: number;
  openMarketListPageScrollY: number;
  event202402ScrollY: number;
};

const initialState: scrollYStateType = {
  homePageScrollY: 0,
  infoListPageScrollY: 0,
  productListPageScrollY: 0,
  openMarketListPageScrollY: 0,
  event202402ScrollY: 0,
};

export const scrollYSlice = createSlice({
  name: 'scrollY',
  initialState,
  reducers: {
    changeHomePageScrollY: (state, action) => {
      state.homePageScrollY = action.payload;
    },
    changeInfoListPageScrollY: (state, action) => {
      state.infoListPageScrollY = action.payload;
    },
    changeProductListPageScrollY: (state, action) => {
      state.productListPageScrollY = action.payload;
    },
    changeOpenMarketListPageScrollY: (state, action) => {
      state.openMarketListPageScrollY = action.payload;
    },
    changeEvent202402ScrollY: (state, action) => {
      state.event202402ScrollY = action.payload;
    },
  },
});
